import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeBupot = new CrudCustom('/tipe-bupots');
export default TipeBupot;
